/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */

const namesGroupsFacilities = require('../data/list_names_groups_facilities');
const commonHelper = require('../helpers/dynpack_common');
const {
    getReviewsData,
} = require('od-modules/parsers/dynpack_common');

function isLastGroupFacility(facility, groupFacilities) {
    return facility === Odigeo._.last(Odigeo._.keys(groupFacilities));
}

function printPolicy(policy) {
    return Odigeo.Utils.breakTextToMultipleLines(policy).join('</br>');
}

function replaceNewLineWithBr(text) {
    return !Odigeo._.isEmpty(text) ? text.replace(/\n/g, '</br>') : '';
}

function getDefaultData(model) {
    const accommodationDealInformation = model.get('accommodationDealInformation') || {};

    return {
        accommodationDealInformation,
        namesGroupsFacilities,
        hasDescription: commonHelper.hasSomeDataFilled([
            accommodationDealInformation.description,
            model.get('infoZone'),
            model.get('locationDescriptor'),
        ]),
        hasPolicies: commonHelper.hasSomeDataFilled([
            model.get('hotelPolicy'),
            model.get('checkInPolicy'),
            model.get('checkOutPolicy'),
            accommodationDealInformation.cancellationPolicyDescription,
        ]),
    };
}

function getAccommodationDetailsData(model, widget) {
    const reviewsData = getReviewsData(model.get('accommodationSearchReviews'));
    return Odigeo._.extend({}, model.toJSON(), getDefaultData(model), {
        hasReviews: Odigeo.AB.isDpOrHsaShowTripAdvisorReviews && !!model.get('tripadvisorId'),
        roomSelectionTestPartition: widget.roomSelectionTestPartition,
        isLastGroupFacility: Odigeo._.partialRight(isLastGroupFacility, model.get('groupFacilities')),
        printPolicy: printPolicy,
        replaceNewLineWithBr: replaceNewLineWithBr,
        isLightbox: !!widget.isLightbox,
        reviewsData: reviewsData,
    });
}

function getAccommodationDetailsTabsData(model) {
    const reviewsData = getReviewsData(model.get('accommodationSearchReviews'));

    return Odigeo._.extend({}, model.toJSON(), getDefaultData(model), {
        hasReviews: Odigeo.AB.isDpOrHsaShowTripAdvisorReviews && !Odigeo._.isNull(model.get('tripAdvisorId')),
        hasServices: !Odigeo._.isEmpty(model.get('groupFacilities')),
        reviewsData,
        language: document.body.dataset.language,
    });
}


function formatHotelPolicies(policies = []) {
    const hotelPolicies = {
        fees: [],
        check_in_instructions: [],
        additional_information: [],
    };

    return policies?.length
        ? policies.reduce((
            acc, {type, content}) => {
            acc[type.toLowerCase()].push(content);
            return acc;
        }, hotelPolicies)
        : hotelPolicies;
}


module.exports = {
    getDefaultData,
    getAccommodationDetailsData,
    getAccommodationDetailsTabsData,
    replaceNewLineWithBr,
    printPolicy,
    isLastGroupFacility,
    formatHotelPolicies,
};
